var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2296 19.3151H15.7977V23.3379H11.2296V19.3151ZM0 24.5097H27.6952V18.1416H0V24.5097Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.8663 10.2636H25.4758V14.2449H20.8663V10.2636ZM0 15.4599H27.6952V9.0918H0V15.4599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.95486 5.19456H2.34534V1.21494H6.95486V5.19456ZM0 0V6.36809H27.6952V0H0Z",
    fill: "#F4F4F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.364e8ade92aea578b23b71b704d264c4.svg";
export { ForwardRef as ReactComponent };